export interface CreateMealPlanSubscriptionState {
  isLoading: boolean;
  error: any;
}

export const createMealPlanSubscriptionInitialState: CreateMealPlanSubscriptionState = {
  isLoading: false,
  error: null,
};
